import { baseApi } from './base-api'
import {UserManageForm , ExternalUserManageForm} from "../../data/users/user-manage-form";
import {getPagedResponse, PagedResponse} from "../../../utils/helpers";
import {User} from "../../data/entities/user";
import {UserRole} from "../../data/users/user-roles";
import {buildPagedResponseTags} from "../../../utils/api-utils";

export const userApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.query<PagedResponse<User>, Record<string, any>>({
      query: (params) => ({
        url: `users/getUsers`,
        params: params
      }),
      transformResponse: getPagedResponse
    }),
    getUsersList: build.query<PagedResponse<User>, Record<string, any>>({
      query: (params) => ({
        url: `users/getUsersList`,
        params: params
      }),
      transformResponse: getPagedResponse
    }),
    getUsersOfRole: build.query<User[], UserRole[]>({
      query: (roles) => {
        const params = new URLSearchParams();
        params.append('pageNumber', '1');
        params.append('pageSize', '1000');
        params.append('sortedColumn', 'name');
        params.append('SortedColumnAscending', 'true');

        roles.forEach(role => {
          params.append('roles', role.toString());
        });

        return {
          url: `users/getUsers`,
          params: params
        }
      }
    }),
    getAllUsers: build.query<User[], void>({
      query: () => {
        const params = new URLSearchParams();
        params.append('pageNumber', '1');
        params.append('pageSize', '99999');
        params.append('sortedColumn', 'name');

        return {
          url: `users/getUsers`,
          params: params
        }
      },
      providesTags: (result) => buildPagedResponseTags(result, 'User')
    }),
    getUser: build.query<User, string>({
      query: (userId) => ({
        url: `users/getuser/${userId}`,
      }),
    }),
    createUser: build.mutation<any, UserManageForm>({
      query: (body) => ({
        url: 'users/adduser',
        method: 'post',
        body: body
      }),
    }),
    createExternalUser: build.mutation<any, ExternalUserManageForm>({
      query: (body) => ({
        url: 'users/addexternaluser',
        method: 'post',
        body: body
      }),
    }),
    updateUser: build.mutation<any, UserManageForm>({
      query: (body) => ({
        url: `users/updateuser/${body.id}`,
        method: 'put',
        body: body
      }),
    }),
    deleteUser: build.mutation<any, string>({
      query: (userId) => ({
        url: `users/deleteuser/${userId}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: true,
})

export const { 
  useLazyGetUsersQuery,
  useLazyGetUsersListQuery,
  useLazyGetUserQuery,
  useCreateUserMutation, 
  useCreateExternalUserMutation, 
  useUpdateUserMutation,
  useDeleteUserMutation,
  useGetUsersOfRoleQuery,
  useGetAllUsersQuery
} = userApi
